export default {
    data() {
        return {
            valid: {
                supplier_name: false,
                supplier_primary_phone: false,
                supplier_country: false,
                supplier_email_1: false,
                user_mobile: false,
                user_country: false,
                user_full_name: false,
                user_gender: false
            },
            success: {
                supplier_name: false,
                supplier_primary_phone: false,
                supplier_country: false,
                supplier_email_1: false,
                user_mobile: false,
                user_country: false,
                user_full_name: false,
                user_gender: false
            },
            error: {
                supplier_name: "",
                supplier_primary_phone: "",
                supplier_country: "",
                supplier_email_1: "",
                user_mobile: "",
                user_country: "",
                user_full_name: "",
                user_gender: ""
            },
            errorMessages: {
                supplierNameRequired: {
                    el: "",
                    en: "Supplier Name is required",
                    it: ""
                },
                supplierPrimaryPhoneRequired: {
                    el: "",
                    en: "Supplier Primary Phone is required",
                    it: ""
                },
                supplierCountryRequired: {
                    el: "",
                    en: "Supplier Country is required",
                    it: ""
                },
                supplierEmail1Required: {
                    el: "",
                    en: "Supplier Primary Email is required",
                    it: ""
                },
                userMobileRequired: {
                    el: "",
                    en: "User Mobile is required",
                    it: ""
                },
                userCountryRequired: {
                    el: "",
                    en: "User Country is required",
                    it: ""
                },
                userFullNameRequired: {
                    el: "",
                    en: "User Full Name is required",
                    it: ""
                },
                userGenderRequired: {
                    el: "",
                    en: "User Gender is required",
                    it: ""
                },
                emailValid: {
                    el: "",
                    en: "E-mail must be valid",
                    it: ""
                }
            }
        };
    },

    computed: {
        formValid() {
            return(
                this.valid.supplier_name && 
                this.valid.supplier_primary_phone && 
                this.valid.supplier_country &&
                this.valid.supplier_email_1 && 
                this.valid.user_mobile &&
                this.valid.user_country && 
                this.valid.user_full_name &&
                this.valid.user_gender
            )
        }
    },

    methods: {
        validateSupplierName() {
            if (!this.supplier.supplier_name) {
                this.error.supplier_name = this.errorMessages.supplierNameRequired[
                    this.lang
                ];
            } else {
                this.error.supplier_name = "";
            }
        },

        validateSupplierPrimaryPhone() {
            if (!this.supplier.supplier_primary_phone) {
                this.error.supplier_primary_phone = this.errorMessages.supplierPrimaryPhoneRequired[
                    this.lang
                ];
            } else {
                this.error.supplier_primary_phone = "";
            }
        },

        validateSupplierCountry() {
            if (!this.supplier.supplier_country_id) {
                this.error.supplier_country = this.errorMessages.supplierCountryRequired[
                    this.lang
                ];
            } else {
                this.error.supplier_country = "";
            }
        },

        validateSupplierEmail1() {
            if (!this.supplier.supplier_email_1) {
                this.error.supplier_email_1 = this.errorMessages.supplierEmail1Required[this.lang];
            } else if (!/.+@.+/.test(this.supplier.supplier_email_1)) {
                this.error.supplier_email_1 = this.errorMessages.emailValid[this.lang];
            } else {
                this.error.supplier_email_1 = "";
            }
        },

        validateUserMobile() {
            if (!this.supplier.user_mobile) {
                this.error.user_mobile = this.errorMessages.userMobileRequired[
                    this.lang
                ];
            } else {
                this.error.user_mobile = "";
            }
        },

        validateUserCountry() {
            if (!this.supplier.user_country_id) {
                this.error.user_country = this.errorMessages.userCountryRequired[
                    this.lang
                ];
            } else {
                this.error.user_country = "";
            }
        },

        validateUserFullName() {
            if (!this.supplier.user_full_name) {
                this.error.user_full_name = this.errorMessages.userFullNameRequired[
                    this.lang
                ];
            } else {
                this.error.user_full_name = "";
            }
        },

        validateUserGender() {
            if (!this.supplier.user_gender) {
                this.error.user_gender = this.errorMessages.userGenderRequired[
                    this.lang
                ];
            } else {
                this.error.user_gender = "";
            }
        }
    },

    watch: {
        ["supplier.supplier_name"]: {
            immediate: true,
            handler(val) {
                this.valid.supplier_name = !!val;
                this.success.supplier_name = !!val;
            }
        },

        ["supplier.supplier_primary_phone"]: {
            immediate: true,
            handler(val) {
                this.valid.supplier_primary_phone = !!val;
                this.success.supplier_primary_phone = !!val;
            }
        },

        ["supplier.supplier_country_id"]: {
            immediate: true,
            handler(val) {
                this.valid.supplier_country = !!val;
                this.success.supplier_country = !!val;
            }
        },

        ["supplier.supplier_email_1"]: {
            immediate: true,
            handler(val) {
                this.valid.supplier_email_1 = /.+@.+/.test(val);
                this.success.supplier_email_1 = /.+@.+/.test(val);
            }
        },

        ["supplier.user_mobile"]: {
            immediate: true,
            handler(val) {
                this.valid.user_mobile = !!val;
                this.success.user_mobile = !!val;
            }
        },

        ["supplier.user_country_id"]: {
            immediate: true,
            handler(val) {
                this.valid.user_country = !!val;
                this.success.user_country = !!val;
            }
        },

        ["supplier.user_full_name"]: {
            immediate: true,
            handler(val) {
                this.valid.user_full_name = !!val;
                this.success.user_full_name = !!val;
            }
        },

        ["supplier.user_gender"]: {
            immediate: true,
            handler(val) {
                this.valid.user_gender = !!val;
                this.success.user_gender = !!val;
            }
        },

        resetSuccess(val) {
            if (val) {
                this.success = {
                    supplier_name: false,
                    supplier_primary_phone: false,
                    supplier_country: false,
                    supplier_email_1: false,
                    user_mobile: false,
                    user_country: false,
                    user_full_name: false,
                    user_gender: false
                };

                this.setResetSuccess(false);
            }
        },

        resetValidation: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.error = {
                        supplier_name: "",
                        supplier_primary_phone: "",
                        supplier_country: "",
                        supplier_email_1: "",
                        user_mobile: "",
                        user_country: "",
                        user_full_name: "",
                        user_gender: ""
                    };

                    this.setResetValidation(false);
                }
            }
        }
    }
};
